import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AutoTranslateDirective } from 'app/shared/directives/auto-translate.directive';

export type RequesterTabId = 'home' | 'request' | 'profile';

@Component({
    selector: 'app-requester-tab-bar',
    standalone: true,
    imports: [CommonModule, MatIconModule, RouterLink, AutoTranslateDirective],
    template: `
        <nav class="req-tabbar">
            <a
                *ngFor="let tab of tabs"
                class="req-tabbar__tab"
                [class.req-tabbar__tab--on]="activeTab === tab.id"
                [class.req-tabbar__tab--cta]="tab.id === 'request'"
                [routerLink]="tab.route"
            >
                <mat-icon [svgIcon]="tab.icon"></mat-icon>
                <span autoTranslate>{{ tab.label }}</span>
            </a>
        </nav>
    `,
})
export class RequesterTabBarComponent {
    @Input() activeTab: RequesterTabId = 'home';

    readonly tabs: { id: RequesterTabId; label: string; icon: string; route: string }[] = [
        { id: 'home', label: 'Início', icon: 'heroicons_outline:home', route: '/requester/home' },
        { id: 'request', label: 'Nova', icon: 'heroicons_outline:plus', route: '/requester/request' },
        { id: 'profile', label: 'Conta', icon: 'heroicons_outline:user', route: '/requester/profile' },
    ];
}
